const baseUrl = "/v1/admin/experience";

export const apiUrls = {
  list: `${baseUrl}`,
  create: `${baseUrl}/create`,
  verifyfile: `${baseUrl}/verify`,
  importfile: `${baseUrl}/import`,
  update: (id: number): string => `${baseUrl}/${id}/update`,
  delete: (id: number): string => `${baseUrl}/${id}/delete`,
  details: (id: number): string => `${baseUrl}/${id}/details`,
  changeStatus: (id: number): string => `${baseUrl}/${id}/change-status`,
};
